<template>
  <a
    v-if="props.item.url"
    :href="props.item.url"
    target="_blank"
    class="font-semibold text-on-surface p-2 cursor-pointer text-ellipsis overflow-hidden"
  >
    {{ props.item.name }}
  </a>

  <template v-else>
    <button
      class="font-semibold text-on-surface flex items-center p-2 cursor-pointer text-left"
      @click="isExpanded = !isExpanded"
    >
      <span class="flex-1 text-ellipsis overflow-hidden">
        {{ props.item.name }}
      </span>
      <Icon
        v-if="hasSubItems"
        :size="IconSize.LG"
        :name="IconName.CHEVRON_DOWN"
        class="flex-shrink-0 ml-2"
      />
    </button>
    <div v-if="isExpanded">
      <a
        v-for="subItem in props.item.submenuItems"
        :key="subItem.id"
        target="_blank"
        :href="subItem.url"
        class="text-on-surface block ml-4 px-3 py-2 cursor-pointer text-ellipsis overflow-hidden"
      >
        {{ subItem.name }}
      </a>
    </div>
  </template>
</template>

<script setup lang="ts">
import { Icon, IconName, IconSize } from '@exfluential/ui';
import { ref, computed } from '#imports';
import { MenuItemDto } from '~/api/organizations';

type Props = {
  item: MenuItemDto;
};

const props = defineProps<Props>();

const isExpanded = ref<boolean>(false);
const hasSubItems = computed(() => props.item.submenuItems.length > 0);
</script>
